import { QueryClient } from 'react-query';

export const queryClient = new QueryClient();

export const SERVICE_QUERY_CONFIG = {
  /**
   * staleTime causes the queries to stay stale even after queryClient.(invalidateQueries | removeQueries | resetQueries)
   * yes, I tried them all.
   *
   * I am disabling this for now which means that we don't properly cache queries leading to a few extra api calls
   *
   * TODO: we should find a way to be able to invalidate the queries correctly
   */
  // staleTime: 60 * 60 * 1000,
  cacheTime: 60 * 60 * 1000,
  refetchOnWindowFocus: false,
};

export const SERVICE_PRODUCTS_QUERY_KEY = 'getServiceProducts';

export const SERVICE_RESOURCES_QUERY_KEY = 'getServiceResources';
